import request from '@/utils/request';
export default {
    // 获取到浙政钉id后，请求后台，返回手机号和姓名
    getZZDInfo (code) {
        return request({
            url: '/api/admin/yjzj/qrcode',
            method: 'Get',
            params: { code }
        });
    },
    updateRead (id, mobile) {
        return request({
            url: '/api/lzt/dbsx/updateReadbysxid',
            method: 'GET',
            params: { id, mobile }
        });
    },
};
